// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import {RefObject, useEffect, useRef, useState} from 'react';

export const use_scrollbox = (scroll_ref: RefObject<HTMLDivElement>,
    scroll_on_drag = true)=>
    {
    const [scroll_pos, set_scroll_pos] = useState(0);
    const [click_start_x, set_click_start_x] = useState<number>();
    const [scroll_start_x, set_scroll_start_x] = useState<number>();
    const [is_dragging, set_is_dragging] = useState(false);
    const scroll_wrapper = scroll_ref.current;
    const is_pressed = useRef(false);
    useEffect(()=>{
        if (scroll_ref.current && scroll_on_drag)
        {
            const handle_drag_start = event=>{
                set_click_start_x(event.screenX);
                set_scroll_start_x(scroll_ref.current.scrollLeft);
                is_pressed.current = true;
            };
            const handle_drag_move = event=>{
                if (!is_pressed.current)
                    return;
                event.preventDefault();
                event.stopPropagation();
                if (click_start_x !== undefined &&
                    scroll_start_x !== undefined)
                {
                    const touch_delta = click_start_x - event.screenX;
                    scroll_ref.current.scrollLeft = scroll_start_x +
                        touch_delta;
                    if (Math.abs(touch_delta) > 1)
                        set_is_dragging(true);
                }
            };
            const handle_drag_end = ()=>{
                if (is_dragging && click_start_x !== undefined)
                {
                    set_click_start_x(undefined);
                    set_scroll_start_x(undefined);
                    set_is_dragging(false);
                }
                is_pressed.current = false;
            };
            if (scroll_ref.current.ontouchstart === undefined)
            {
                scroll_ref.current.onmousedown = handle_drag_start;
                scroll_ref.current.onmousemove = handle_drag_move;
                scroll_ref.current.onmouseup = handle_drag_end;
                scroll_ref.current.onmouseleave = handle_drag_end;
            }
        }
    }, [
        scroll_wrapper,
        click_start_x,
        is_dragging,
        scroll_start_x,
    ]);
    const scroll = (val: number, dir: 'fw' | 'bw' = 'fw',
        unit: 'px' | '%' = 'px')=>
        {
        const cur = scroll_wrapper.scrollLeft;
        const max = scroll_wrapper.scrollWidth - scroll_wrapper.clientWidth;
        const v = unit == '%' ? max * val / 100 : val;
        scroll_wrapper.scrollLeft = dir=='fw' ? cur + v : Math.max(0, cur - v);
    };
    useEffect(()=>{
        if (!scroll_wrapper)
            return;
        const max = scroll_wrapper.scrollWidth - scroll_wrapper.clientWidth;
        const handle_scroll = ()=>{
            set_scroll_pos(scroll_wrapper.scrollLeft / max);
        };
        scroll_wrapper.addEventListener('scroll', handle_scroll);
        return ()=>{
            scroll_wrapper.removeEventListener('scroll', handle_scroll);
        };
    }, [scroll_wrapper]);
    return {is_dragging, scroll, scroll_pos};
};
